<div (keyup.escape)="close()" [class.show]="show$ | async" class="search">
  <button
    (click)="close()"
    class="ltr:right-12 rtl:left-12 top-4 absolute"
    color="primary"
    mat-icon-button
    aria-label="close"
    type="button">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>

  <!-- <input #searchInput (keyup.enter)="search()" [formControl]="searchCtrl" class="search-input" placeholder="Search..."/> -->
  <div class="py-4" fxLayoutAlign="center center">
    <div
      class="search-box rounded-full border px-4"
      fxFlex.lt-md="auto"
      fxLayout="row"
      fxLayoutAlign="start center">
      <mat-form-field floatLabel="never">
        <mat-select
          [(value)]="selectedValue"
          name="food"
          (selectionChange)="searchValueChange(selectedValue)">
          <mat-option *ngFor="let food of foods" [value]="food.value">
            {{ food.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <input
        (ngModelChange)="onGetSearchValue($event)"
        class="search-text px-4 py-3 border-0 outline-none w-full bg-transparent"
        placeholder="Enter your job or candidate search content here .."
        type="search"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        aria-label="search" />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of searchedData" [value]="option.label">
          {{ option.label }}
        </mat-option>
      </mat-autocomplete>

      <ic-icon class="search-icon" [icIcon]="icSearch" size="20px"></ic-icon>
    </div>
  </div>

  <!-- <div class="search-hint">Hit enter to search</div> -->
</div>

<div (click)="close()" *ngIf="show$ | async" class="search-overlay"></div>
